/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Customer_Total_CountInputs */

const vi_customer_total_count = /** @type {(inputs: Customer_Total_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tổng ${i?.count} khách hàng`)
};

/**

* @param {Customer_Total_CountInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_total_count = /** @type {((inputs: Customer_Total_CountInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Total_CountInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_total_count(inputs)
});